var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Attachment File") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Attachment-File",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,14.6666667 C9.33333333,17.6121853 11.721148,20 14.6666667,20 C17.6121853,20 20,17.6121853 20,14.6666667 C20,11.721148 17.6121853,9.33333333 14.6666667,9.33333333 C11.721148,9.33333333 9.33333333,11.721148 9.33333333,14.6666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.6666667,
    y1: 12,
    x2: 14.6666667,
    y2: 17.3333333,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 14.6666667,
    x2: 17.3333333,
    y2: 14.6666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,17.3333333 L1.33333333,17.3333333 C0.596953667,17.3333333 0,16.7363797 0,16 L0,1.33333333 C0,0.596953667 0.596953667,0 1.33333333,0 L10.7813333,0 C11.1347086,0 11.4736014,0.140428224 11.7235556,0.390222222 L14.2764444,2.94311111 C14.5262384,3.19306523 14.6666667,3.53195804 14.6666667,3.88533333 L14.6666667,6",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentFile);
export default __webpack_public_path__ + "static/media/attachment-file.0e614838f549d940fe267da59405f571.svg";
export { ForwardRef as ReactComponent };